import { apiResourceUrl } from "@ploy-lib/core";
import { BaseResource } from "./BaseResource";
class FormFieldResource extends BaseResource {
    pk() {
        return this.availableFormFieldId?.toString();
    }
    static create() {
        return super.create().extend({
            schema: [this]
        });
    }
}
FormFieldResource.urlRoot = apiResourceUrl("formfield");
export { FormFieldResource };
//# sourceMappingURL=FormFieldResource.js.map